
import React, { useEffect } from 'react';
import clsx from 'clsx';

import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component';
import ContentWrapper, {
    ContentColumn,
} from '@/layouts/ContentWrapper/ContentWrapper.component';
import Heading from '@/elements/Heading/Heading.component';
import Text from '@/elements/Text/Text.component';

import { IProps } from '@/blocks/DonationConfirmationBlock/DonationConfirmationBlock.interface';
import '@/blocks/DonationConfirmationBlock/DonationConfirmationBlock.styles.css';
import { dataLayerPush } from '@/utils/gtm';

export const DonationConfirmationBlock: React.FC<IProps> = ({
    title,
    description,
    gtmDataLayerObject,
    className,
    ...blockWrapperProps
}) => {
    useEffect(() => {
        dataLayerPush(gtmDataLayerObject);
    }, [gtmDataLayerObject]);

    return (
        <BlockWrapper
            className={clsx('donationConfirmationBlock', className)}
            {...blockWrapperProps}
            layout="hero"
        >
            <ContentWrapper>
                <ContentColumn layout="two-thirds">
                    {title && (
                        <Heading level={1} className="donationConfirmationBlock__title" html={title} />
                    )}
                    {description && (
                        <Text className="donationConfirmationBlock__description" html={description} />
                    )}
                </ContentColumn>
            </ContentWrapper>
        </BlockWrapper>
    );
};
